import { Tabs, TabsProps, withDefaults } from 'theme/components';

export default withDefaults<TabsProps>({
  bg: 'white',
  borderBottomLeftRadius: 'large',
  borderBottomRightRadius: 'large',
  boxShadow: 'layout',
})(Tabs);
